import { render, staticRenderFns } from "./RecipeOrder.vue?vue&type=template&id=5b83e624&scoped=true"
import script from "./RecipeOrder.vue?vue&type=script&lang=js"
export * from "./RecipeOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83e624",
  null
  
)

export default component.exports